module.exports = __webpack_public_path__ + "static/media/Q2_Back_Left.e96ddc51.png";